import React, { useCallback, useState } from 'react'
import { isEmptyString } from '../../../../utils/string-utils'
import { IconButton, Tooltip } from '@mui/material'
import ConstraintsModal from './constraints-modal'
import ShieldIcon from '@mui/icons-material/Shield'

export interface ViewConstraintsModalTriggerProps {
  strategyId: string
  strategyName: string
  isApiConnected: boolean
  constraintsUrl: string | null
  controlUpdateConstraintUrl: string | null
}

const ConstraintsModalTrigger: React.FC<ViewConstraintsModalTriggerProps> = (props) => {
  const { strategyId, strategyName, isApiConnected, constraintsUrl, controlUpdateConstraintUrl } = props
  const isDisabled = !isApiConnected || isEmptyString(constraintsUrl)

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  const openModal = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  return (
    <>
      <ConstraintsModal
        open={isModalOpen}
        onClose={closeModal}
        strategyId={strategyId}
        title={`${strategyName} Constraints`}
        dataUrl={constraintsUrl}
        postUrl={controlUpdateConstraintUrl}
      />

      <Tooltip title='View constraints'>
        <span>
          <IconButton size='small' disabled={isDisabled} onClick={openModal}>
            <ShieldIcon/>
          </IconButton>
        </span>
      </Tooltip>
    </>
  )
}

export default React.memo(ConstraintsModalTrigger)
